export default {
    femaleWelcome: 'Seja bem vinda, <strong>{name}</strong>',
    maleWelcome: 'Seja bem vindo, <strong>{name}</strong>',

    paymentValidate: {
        button: 'Entrar em contato',
        message: 'Seu pagamento foi aprovado! Clique aqui para ativar sua assinatura',
        paragraph: 'Está com problemas para concluir sua assinatura? Nós te ajudamos.',
    }
}